import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../apiCalls/rtkBaseQuery';

export const cutOffApi = createApi({
    baseQuery,
    reducerPath: 'cutOffApi',
    tagTypes: ['cutOff'],
    endpoints: (builder) => ({
        getCutOffList: builder.query({
            query: () => ({
                url: '/admin/site/cut-off-dates',
                method: 'GET',
            }),
            keepUnusedDataFor: 0,
            providesTags: ['cutOff'],
        }),
        updateCutOffList: builder.mutation({
            query: (data) => ({
                url: '/admin/site/cut-off-dates',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['cutOff'],
        }),
    }),
});

export const {
    useGetCutOffListQuery,
    useUpdateCutOffListMutation,
} = cutOffApi;
